<template>
    <div class="distribute-manage">
        <keep-alive :include="cachedViews">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>
<script>
export default {
    name: 'distributeManage',
    data() {
        return {
        };
    },
    computed: {
        cachedViews() {
            return this.$store.state.cachedViews;
        }
    }
};
</script>
<style lang="less">
.distribute-manage{
    flex: 1;
    display: flex;
}
</style>